<template>
  <v-card v-if="item.dir && title"
          :id="item.id"
          ref="sticky"
          :elevation="elevation"
          :color="color"
          :dark="dark"
          class="px-1 py-2 store-observed-section rounded-0"
          :class="classes"
          :style="style"
  >
    <v-container :id="headingId" class="py-0">
      <div :class="headingClass">
        {{ title }}
      </div>
      <span v-if="timeRange" class="subtitle-2" v-text="timeRange" />
      <div v-if="!isMobile && item.sections.length > 1" class="d-flex flex-row">
        <v-chip-group v-if="item.sections.length > 1"
                      class="flex-grow-1"
                      :column="expanded"
                      :dark="dark"
                      :light="!dark"
                      center-active
                      :show-arrows="true"
        >
          <v-chip v-for="(section, index) in item.sections"
                  :key="`s-${index}`"
                  :to="{name: 'showcase', params: {section: section._id}}"
                  label
                  :dark="dark"
                  :light="!dark"
                  outlined
                  v-text="section.dirLabel || section._id"
          />
        </v-chip-group>
      </div>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: 'Section',
  components: { },
  props: {
    item: { type: Object, default: () => ({}) },
    depth: { type: Number, default: 0 },
    stickyTop: { type: Number, default: 0 },
    active: { type: Boolean, default: false },
  },
  data: () => ({
    expanded: true,
  }),
  computed: {
    dark() {
      if (this.active && this.recolorOnSticking) return this.$store.state.theme.stickySectionDark;
      return this.$store.state.theme.menuSectionDark;
    },
    color() {
      if (this.active && this.recolorOnSticking) return this.$store.state.theme.stickySectionColor;
      return this.$store.state.theme.menuSectionColor;
    },
    elevation() {
      if (this.active && this.recolorOnSticking) {
        return this.$store.state.theme.stickySectionElevation;
      }
      return 0;
    },
    style() {
      if (!this.sticky) return {};
      return { top: `${this.stickyTop}px` };
    },
  },
  created() {
    this.isMobile = this.$vuetify.breakpoint.name === 'xs';
    this.sticky = this.$store.state.theme.stickySection;
    this.recolorOnSticking = this.sticky
      ? Array.isArray(this.item.content) && this.item.content.length > 0 : false;
    this.headingClass = this.getHeadingClass();
    this.classes = this.sticky ? 'restion-store__sticky-title' : null;
    if (!this.item.root) {
      this.putMenu = this.title !== null;
    } else {
      const { settings } = this.$store.state.data;
      this.putMenu = !settings.disable_navigation_menu;
    }
    this.headingId = `store-section-${this.item.id}`;
    this.title = this.item.hideTitle ? null : this.item.name;
    if (this.item.time_limited) {
      const range = this.item.time_limit_range;
      this.timeRange = this.$tools.time.range(range[0], range[1]);
    } else {
      this.timeRange = null;
    }
  },
  methods: {
    toggleExpanded() {
      this.expanded = !this.expanded;
    },
    getHeadingClass() {
      const {
        stickyHeader, menuSectionRight, stickySection,
        navigationButton, navigationDesktop
      } = this.$store.state.theme;
      const navButtonHidden = !this.isMobile && navigationDesktop === 'constant';
      const marginsR = !navButtonHidden && !stickyHeader && menuSectionRight && stickySection;
      const marginsL = !navButtonHidden && !stickyHeader && !menuSectionRight && stickySection;
      return {
        'ml-8 pl-8': marginsL && navigationButton === 'top-left-fab',
        'ml-6 pl-6': marginsL && navigationButton === 'top-left',
        'mr-8 pr-8': marginsR && navigationButton === 'top-right-fab',
        'mr-6 pr-6': marginsR && navigationButton === 'top-right',
        'text-right': menuSectionRight,
        'text-h4': this.depth === 0,
        'text-h5': this.depth === 1,
        'text-h6': this.depth >= 2,
      };
    },

  }
};
</script>
